/**
 * Where an explanation's bubble goes (decision 261; client, 2026-10-29: "when
 * hovering on the open to buy help or tooltip icons … the message box flickers
 * really fast and bad").
 *
 * The bubble once chose "above" with one test (the ? more than 160px down)
 * and lifted itself above its point with another (its point more than 160px
 * down) — eight pixels apart. A ? between 160 and 168px down, where a report's
 * headings sit since reports fill the screen (decision 257), got a bubble
 * drawn over itself: the pointer was then on the bubble, the ? lost it, the
 * bubble went, the ? had it again — many times a second.
 *
 * One decision now, made once, with the edge the bubble hangs from: it can
 * never cover the ? it explains. Pure, so that is proved for every height.
 */

export const BUBBLE_WIDTH = 280;
const GAP = 8;
/** Room a bubble needs above its ? before it goes there rather than below. */
const ROOM_ABOVE = 160;

export interface BubblePlace {
  /** Above the ?: `top` is the bubble's bottom edge. Below: its top edge. */
  readonly above: boolean;
  readonly top: number;
  readonly left: number;
}

export function placeBubble(
  trigger: {
    readonly top: number;
    readonly bottom: number;
    readonly left: number;
    readonly width: number;
  },
  viewportWidth: number,
): BubblePlace {
  const centred = trigger.left + trigger.width / 2 - BUBBLE_WIDTH / 2;
  const left = Math.max(GAP, Math.min(centred, viewportWidth - BUBBLE_WIDTH - GAP));
  // Prefer above; below when there is not room, so it never runs off the top.
  const above = trigger.top > ROOM_ABOVE;
  return { above, top: above ? trigger.top - GAP : trigger.bottom + GAP, left };
}
